import { useMemo } from 'react';
import { v4 } from 'uuid';

/**
 * Hook that returns unique id which is persistent during whole component lifecycle
 */
export const useUniqueId = (staticId?: string) => useMemo(() => (staticId === undefined ? v4() : staticId), [staticId]);
